var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{key:_vm.key,ref:"date",staticClass:"deploy-date"},[_vm._v("20240908-1548 CDT -0500 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }